import { FontStyleHelper } from '../../../shared/helpers/font-style-helper';
var CalibrationGoModelToDataUtil = /** @class */ (function () {
    function CalibrationGoModelToDataUtil(goModel) {
        this.goModel = goModel;
    }
    Object.defineProperty(CalibrationGoModelToDataUtil.prototype, "calibrationMarkDetail", {
        get: function () {
            return {
                calibrationDetail: this.calibrationDetail,
                showCalibrationDigit: !!this.goModel['showCalibrationDigit'],
                calibrationDigitDetail: this.calibrationDigitDetail
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationGoModelToDataUtil.prototype, "calibrationDigitFont", {
        get: function () {
            var calibrationDigitFontStyle = this.goModel['calibrationDigitFontStyle'];
            var calibrationDigitIsUnderline = this.goModel['calibrationDigitIsUnderline'];
            var calibrationDigitColor = this.goModel['calibrationDigitColor'];
            return {
                fontSize: FontStyleHelper.fontSize(calibrationDigitFontStyle),
                isBold: FontStyleHelper.isBold(calibrationDigitFontStyle),
                isItalic: FontStyleHelper.isItalic(calibrationDigitFontStyle),
                isUnderline: calibrationDigitIsUnderline,
                color: calibrationDigitColor,
                fontFamily: FontStyleHelper.fontFamily(calibrationDigitFontStyle)
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationGoModelToDataUtil.prototype, "calibrationDigitDetail", {
        get: function () {
            return {
                integerDigits: this.goModel['integerDigits'],
                fractionDigits: this.goModel['fractionDigits'],
                calibrationDigitFont: this.calibrationDigitFont
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationGoModelToDataUtil.prototype, "calibrationDetail", {
        get: function () {
            return {
                masterCalibrations: this.goModel['masterDivisionNumber'],
                subCalibrations: this.goModel['subDivisionNumber'],
                calibrationColor: this.goModel['calibrationColor']
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationGoModelToDataUtil.prototype, "showPercentage", {
        get: function () {
            return !!this.goModel['showPercentage'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationGoModelToDataUtil.prototype, "percentageFont", {
        get: function () {
            if (this.showPercentage === false || !this.goModel['percentageFontStyle']) {
                return undefined;
            }
            return {
                fontSize: FontStyleHelper.fontSize(this.goModel['percentageFontStyle']),
                isBold: FontStyleHelper.isBold(this.goModel['percentageFontStyle']),
                isItalic: FontStyleHelper.isItalic(this.goModel['percentageFontStyle']),
                isUnderline: this.goModel.percentageIsUnderline,
                color: this.goModel['percentageColor'],
                fontFamily: FontStyleHelper.fontFamily(this.goModel['percentageFontStyle'])
            };
        },
        enumerable: true,
        configurable: true
    });
    CalibrationGoModelToDataUtil.prototype.toViewData = function () {
        var data = {
            showCalibration: !!this.goModel['showScale'],
        };
        data.calibrationMarkDetail = this.calibrationMarkDetail;
        if (this.goModel.hasOwnProperty('showPercentage')) {
            data.showPercentage = this.goModel.showPercentage;
            data.percentageFont = this.percentageFont;
        }
        return data;
    };
    return CalibrationGoModelToDataUtil;
}());
export { CalibrationGoModelToDataUtil };
